import './bootstrap';
import 'vidstack/bundle';
import 'vidstack/icons';
import { ListeningTracker } from './listening-tracker';
import { decodeBlurHash } from 'fast-blurhash';
import PWAPrompts from './components/PWAPrompts';

// Import the PWA registration
import { registerSW } from 'virtual:pwa-register';

// Initialize PWA registration
const initializePWA = async () => {
    console.log('Initializing PWA registration');
    const { registerSW } = await import('virtual:pwa-register');
    return registerSW({
        immediate: true,
        onNeedRefresh() {
            console.log('The Service worker detected new version');
            PWAPrompts.initialize().then(() => {
                PWAPrompts.show().then(shouldUpdate => {
                    console.log('User chose to update:', shouldUpdate);
                    if (shouldUpdate) {
                        console.log('Reloading page for update...');
                        // Force the service worker to update
                        if ('serviceWorker' in navigator) {
                            navigator.serviceWorker.getRegistration().then(registration => {
                                if (registration && registration.waiting) {
                                    registration.waiting.postMessage({ type: 'SKIP_WAITING' });
                                }
                            });
                        }
                        window.location.reload();
                    } else {
                        console.log('Update postponed by user');
                    }
                });
            });
        }
    });
};

// Wait for Livewire (and Alpine) to be available
// This ensures Alpine is loaded by Livewire before we initialize PWAPrompts and PWA

document.addEventListener('livewire:load', async () => {
    try {
        // Initialize PWAPrompts first
        await PWAPrompts.initialize();
        await initializePWA();

        // Re-initialize on Livewire navigation
        document.addEventListener('livewire:navigated', async () => {
            await PWAPrompts.initialize();
            await initializePWA();
        });
    } catch (error) {
        console.error('Error initializing PWA:', error);
    }
});

// Make decodeBlurHash available globally
window.decodeBlurHash = decodeBlurHash;
// Make ListeningTracker available globally
window.ListeningTracker = ListeningTracker;